// Persistencia de la última ciudad (cantón) visitada para poder regresar a ella
// desde rutas sin contexto de ciudad (ej. página 404). Guarda solo la URL base
// del cantón (/:iso2/:canton), no subrutas, árboles ni vistas de administración.
export const LAST_CITY_URL_STORAGE_KEY = 'ArbolEc_lastCityUrl'

// Persiste la URL base del cantón activo. Ignora valores vacíos.
export const saveLastCityUrl = cantonUrl => {
  if (!cantonUrl) return
  try {
    window.localStorage.setItem(LAST_CITY_URL_STORAGE_KEY, cantonUrl)
  } catch (error) {
    console.warn('No se pudo persistir la última ciudad visitada:', error)
  }
}

// Lee la última ciudad visitada. Retorna la URL o null si no existe o falla.
export const loadLastCityUrl = () => {
  try {
    return window.localStorage.getItem(LAST_CITY_URL_STORAGE_KEY) || null
  } catch (error) {
    return null
  }
}
